<template>
  <div>
    <span class="market-name">{{ market }}</span>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'market-theme',
  data() {
    return {};
  },
  computed: {
    ...mapState({
      market: state => state.theme.market,
    }),
  },

  async mounted() {},
};
</script>

<style scoped>
.market-name {
  display: block;
  position: fixed;
  width: 100%;
  margin: 0px auto;
  font-size: 14px;
}
</style>
